import {createSlice} from '@reduxjs/toolkit'
import React from 'react'

const initialState = {
    Title: (<> <h1></h1> </>),
    isLogin: false,
    feauteFlags: {
        disponibleMedicamentos: false,
        verNotificaciones: false,
        verNucleoFamiliar: false,
        verPerfil: false,
        verRedesSociales: false
    },
    isFeatureFlagLoad: false
}

export const configurationSlice = createSlice({
    name: "configuration",
    initialState,
    reducers: {
        setConfiguration: (state,action) => {
            state.Title = action.payload
        },
        setIsLogin: (state,action) => {
            state.isLogin = action.payload
        },
        setFeatureFlags: (state, action) => {
            const records = action.payload;
            records.forEach(r=>{
                if(r.nombre === 'DISPONIBLE_MEDICAMENTOS'){
                    state.feauteFlags.disponibleMedicamentos = r.esWeb;
                } else if (r.nombre === 'VER_NOTIFICACIONES'){
                    state.feauteFlags.verNotificaciones = r.esWeb;
                } else if (r.nombre === 'VER_NUCLEO_FAMILIAR') {
                    state.feauteFlags.verNucleoFamiliar = r.esWeb;
                } else if (r.nombre === 'VER_PERFIL'){
                    state.feauteFlags.verPerfil = r.esWeb;
                } else if (r.nombre === 'VER_REDES_SOCIALES'){
                    state.feauteFlags.verRedesSociales = r.esWeb;
                }
            })
            
        },
        setIsFeatureFlagLoad: (state,action) => {
            state.isFeatureFlagLoad = action.payload
        },
    }
})

export const {setConfiguration,setIsLogin,setFeatureFlags,setIsFeatureFlagLoad} = configurationSlice.actions

export default configurationSlice.reducer